import type { RoleId, RoleName } from "@/api/accessAPI";

export type Roles = {
    [key in RoleName]: RoleId;
};

export const roles: Roles = {
    unknown: -1,
    normalUser: 10,
    admin: 30,
    compendiaAdmin: 60,
    superAdmin: 100,
};

export const getRoleName = (roleNumber: RoleId): RoleName => {
    return (Object.keys(roles) as RoleName[]).find((key) => roles[key] === roleNumber) || "unknown";
};

export const getRoleId = (roleName: RoleName): RoleId => {
    return roles[roleName] || -1;
};
